import React from "react";

import Contact from "./Contact";

const Footer = () => {
  return (
    <footer>
      <h3>
        Made with <span style={{ color: "red" }}>♥</span> in 🇮🇳
      </h3>
      <Contact />
    </footer>
  );
};
export default Footer;
